import { useState } from 'react';

const useControlledValue = (value, defaultValue) => {
    const [internalValue, setInternalValue] = useState(defaultValue || "");
    const isControlled = value !== undefined;
    const currentValue = isControlled ? value : internalValue;
    return {
        value: currentValue,
        isControlled,
        setInternalValue,
    };
};

export { useControlledValue };
